import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { GraduationCap, BookOpenCheck, Clock, CheckCircle2, Award, Loader2, PlayCircle } from "lucide-react";

export default function DocenteCursos() {
  const [items, setItems] = useState([]);
  const [certified, setCertified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/training/my-courses");
      setItems(data.courses || []);
      setCertified(!!data.certified);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const act = async (course, action) => {
    setBusy(course.id);
    try {
      await api.post(`/training/courses/${course.id}/${action}`);
      if (action === "complete") toast.success(`Completaste "${course.title}" 🎉`);
      await load();
    } catch {
      toast.error("No se pudo actualizar el curso.");
    } finally {
      setBusy(null);
    }
  };

  const total = items.length;
  const done = items.filter((c) => c.enrollment_status === "completed").length;

  return (
    <div className="space-y-6" data-testid="docente-cursos-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#2C49A0]">Capacitación Docente</p>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#1F2547] flex items-center gap-2">
            <GraduationCap className="text-[#2C49A0]" /> Mis cursos
          </h1>
          <p className="text-sm text-[#6E7591] mt-1">Completa los cursos requeridos para obtener tu certificación.</p>
        </div>
        <div className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-2xl font-bold text-sm ${certified ? "bg-[#E9F8EF] text-[#16A34A]" : "bg-[#FFF7DA] text-[#9C7A18]"}`} data-testid="cert-badge">
          <Award size={18} /> {certified ? "Docente certificado" : `Progreso: ${done}/${total}`}
        </div>
      </div>

      {loading ? (
        <div className="jasq-card p-10 text-center text-sm text-[#6E7591]">Cargando cursos…</div>
      ) : items.length === 0 ? (
        <div className="jasq-card p-10 text-center text-sm text-[#6E7591]" data-testid="cursos-empty">Aún no hay cursos disponibles.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-3" data-testid="cursos-grid">
          {items.map((c) => {
            const completed = c.enrollment_status === "completed";
            const enrolled = c.enrollment_status === "enrolled";
            return (
              <div key={c.id} className="jasq-card p-5" data-testid={`curso-${c.id}`}>
                <div className="flex items-start gap-3">
                  <div className="w-11 h-11 rounded-2xl grid place-items-center bg-[#EAF0FF] text-[#2C49A0] shrink-0">
                    <BookOpenCheck size={20} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h3 className="font-extrabold text-[#1F2547]">{c.title}</h3>
                      {c.required && <span className="text-[9px] font-bold uppercase bg-[#FDEBF4] text-[#D63384] rounded px-1.5 py-0.5">Requerido</span>}
                    </div>
                    <p className="text-sm text-[#6E7591] mt-0.5">{c.description || "Curso de formación interna."}</p>
                    <p className="text-xs text-[#A6ACC1] mt-1 flex items-center gap-1"><Clock size={12} /> {c.duration_min} min</p>
                  </div>
                </div>
                <div className="mt-4">
                  {completed ? (
                    <span className="inline-flex items-center gap-2 text-sm font-bold text-[#16A34A]" data-testid={`curso-done-${c.id}`}>
                      <CheckCircle2 size={18} /> Completado
                    </span>
                  ) : (
                    <button
                      onClick={() => act(c, enrolled ? "complete" : "enroll")}
                      disabled={busy === c.id}
                      data-testid={`curso-action-${c.id}`}
                      className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-[#2C49A0] text-white font-bold text-sm hover:bg-[#1F2547] transition-colors disabled:opacity-60"
                    >
                      {busy === c.id ? <Loader2 size={16} className="animate-spin" /> : <PlayCircle size={16} />}
                      {enrolled ? "Marcar como completado" : "Inscribirme"}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
